module.exports = __webpack_public_path__ + "img/cf247-logo--white.f07e8010.svg";